import isPgaLink from '@utils/isPgaLink'

function coachProfileBookingUrl(coach) {
  const raw = coach?.bookingUrl ?? coach?.bookingURL
  return typeof raw === 'string' ? raw.trim() : ''
}

/**
 * Coach Tools exposes `bookable` on the profile, but PGA Coach scheduling
 * (`my.pga.com/.../schedule`) requires at least one non-inactive lesson type.
 * When `lessonTypes` is omitted (e.g. some Algolia hits), keep trusting `bookable`.
 */
export function coachHasActiveLessonTypes(coach) {
  const lessonTypes = coach?.coach?.lessonTypes
  if (!Array.isArray(lessonTypes)) {
    return true
  }
  if (lessonTypes.length === 0) {
    return false
  }
  return lessonTypes.some(
    (lessonType) => lessonType?.status
      && String(lessonType.status).toUpperCase() !== 'INACTIVE',
  )
}

/**
 * True when the coach should expose an on-platform PGA schedule link (not external).
 */
export function coachIsPgaScheduleBookable(coach) {
  if (!coach?.bookable) {
    return false
  }
  const url = coachProfileBookingUrl(coach)
  if (!url) {
    return false
  }
  try {
    if (!isPgaLink(url)) {
      return false
    }
  } catch {
    return false
  }
  return coachHasActiveLessonTypes(coach)
}

/**
 * Booking URL for coach profile JSON-LD (SiteNavigationElement Book Now).
 * PGA schedule links require active lesson types; external URLs keep the
 * legacy `bookable && bookingUrl` gate (CTA uses the external-tool path).
 */
export function coachProfileJsonLdBookingUrl(profile) {
  const url = coachProfileBookingUrl(profile)
  if (!url) {
    return null
  }
  try {
    if (isPgaLink(url)) {
      return coachIsPgaScheduleBookable(profile) ? url : null
    }
  } catch {
    return null
  }
  if (!profile?.bookable) {
    return null
  }
  return url
}
